import React from "react";
import { socialLinks } from "./data";

export default function FooterBottom(): React.ReactNode {
  return (
    <div className="flex md:flex-row flex-col-reverse gap-8 justify-between items-center w-full text-center xs:text-start">
      {/* copyright section. Full-opacity white reads more solidly than the
          translucent text-white/80 this used to be, on either footer
          background variant. */}
       <p className="text-white">
        © <span className="uppercase">Lfyd services private limited</span> • All rights reserved
      </p>

      {/* social links section */}
      <div className="flex items-center gap-12">
        {socialLinks.map((social, index) => (
          <a target="_blank" key={index} href={social.href} aria-label={social.alt}>
            {React.createElement(social.icon as React.ElementType, {
              className: "md:size-6 sm:size-8 size-6",
            })}
          </a>
        ))}
      </div>
    </div>
  );
}

//  {socialLinks.map((social, index) => (
//         <a key={index} href={social.href} aria-label={social.alt}>
//           {React.createElement(social.icon, {
//             className: "w-6 h-6",
//           })}
//         </a>
//       ))}


